import { Listbox, Transition } from "@headlessui/react";
import React, { Fragment, useState } from "react";
import { ReactComponent as DropdownIcon } from "../../../../../../../assets/svg/solobuilder/dropdown.svg"
import { transformFonts } from "./handleCustomFontFace"

interface IDropdown {
  options: any;
  selected: any;
  onChange: (option: { name: string }) => void;
  disabled?: boolean
  cursorStyle?: any
  type?: string;
  width?: number
  id?: string;
  placeholder?: string;
}

export const Dropdown: React.FC<IDropdown> = ({ cursorStyle, disabled, options, width, selected, onChange, type, id, placeholder }) => {
  let selectedName = selected.name
  var optionList: any;
  var customFontsList: any
  if (type === "fontFamily") {
    optionList = [...options?.systemFonts]
    optionList = transformFonts(optionList);
    customFontsList = options?.customFonts ? [...options?.customFonts] : []
  } else {
    optionList = [...options];
  }
  return (
    <div id={id} className="relative col-span-1 bg-white text-gray-900" >
      <Listbox disabled={disabled} value={selected} onChange={onChange}>
        {
          ({ open }) => {
            return <>
              <Listbox.Button style={{
                borderRadius: "2px", border: open ? "1px solid #e27841" : "1px solid #7D84924B",
                display: "flex", alignItems: "center", height: "28px", width: width ? width : "170px", cursor: "pointer", padding: "10px 4px 10px 4px"
              }}
                className="relative text-lx rounded-lg bg-white text-left focus:outline-none">
                {selected.name?<span style={{ minWidth: "20px", fontSize: "11px", fontWeight: 600, color: "#282B31" }}>{selected.name}</span>:
                <span style={{fontSize:"12px", color: "#969BA5"}}>{placeholder || null}</span>}
                <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                  <DropdownIcon height={"8px"} width="9px" className="text-gray-400" />
                </span>
              </Listbox.Button>
              <Transition
                as={Fragment}
                leave="transition ease-in duration-100"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Listbox.Options style={{ minWidth: width ? width : "170px", maxHeight: "170px", border: "1px solid rgba(125, 132, 146, 0.294)", boxShadow: "rgba(125, 132, 146, 0.11) 0px 5px 8px", paddingBottom: "10px" }}
                  className="top-11 absolute overflow-auto rounded-md bg-white focus:outline-none z-40">
                  {customFontsList?.length > 0 && <div style={{ color: "#969BA5", fontWeight: 600, fontSize: "11px", margin: "10px 10px 0px 10px" }}>Custom Font</div>}
                  {customFontsList?.length > 0 && customFontsList.map((type: any, colorIdx: any) => (
                    <Listbox.Option
                      key={colorIdx}
                      style={{ margin: "10px 10px 0px 10px" }}
                      className="relative cursor-pointer select-none"
                      value={type}
                    >
                      {({ active }) => {
                        return <>
                          <span
                            style={{ fontWeight: 600, minWidth: "20px", fontSize: "11px", lineHeight: "normal" }}
                            className={`block truncate ${active||type.name === selectedName ? "text-selectedText_color" : "text-unselectedText_color"}`}
                          >
                            {type.name}
                          </span>
                        </>
                      }}
                    </Listbox.Option>

                  ))}
                  {customFontsList?.length > 0 && <div style={{ borderBottom: "1px solid #969BA5", marginTop: "20px", marginBottom: "10px" }}></div>}

                  {type === "fontFamily" ?
                    <>
                      { optionList?.google?.length > 0 && (
                          <>
                            {optionList.google.map((type: any, colorIdx: any) => (
                              <Listbox.Option
                                key={colorIdx}
                                style={{ margin: "10px 10px 0px 10px" }}
                                className="relative cursor-pointer select-none"
                                value={type}
                              >
                                {({ active }) => {
                                  return <>
                                    <span
                                      style={{ fontWeight: 600, minWidth: "20px", fontSize: "11px", lineHeight: "normal" }}
                                      className={`block truncate ${active||type.name === selectedName ? "text-selectedText_color" : "text-unselectedText_color"}`}
                                    >
                                      {type.name}
                                    </span>
                                  </>
                                }}
                              </Listbox.Option>
                            ))}
                          </> 
                        )
                      }
                      { optionList?.custom?.length > 0 && (
                          <>
                            {optionList.custom.map((type: any, colorIdx: any) => (
                              <Listbox.Option
                                key={colorIdx}
                                style={{ margin: "10px 10px 0px 10px" }}
                                className="relative cursor-pointer select-none"
                                value={type}
                              >
                                {({ active }) => {
                                  return <>
                                    <span
                                      style={{ fontWeight: 600, minWidth: "20px", fontSize: "11px", lineHeight: "normal" }}
                                      className={`block truncate ${active||type.name === selectedName ? "text-selectedText_color" : "text-unselectedText_color"}`}
                                    >
                                      {type.name}
                                    </span>
                                  </>
                                }}
                              </Listbox.Option>
                            ))}
                          </>
                        )
                      }
                    </>
                  : 
                    optionList.map((type: any, colorIdx: any) => (
                      <Listbox.Option
                        key={colorIdx}
                        style={{ margin: "10px 10px 0px 10px" }}
                        className="relative cursor-pointer select-none"
                        value={type}
                      >
                        {({ active }) => {
                          return <>
                            <span
                              style={{ fontWeight: 600, minWidth: "20px", fontSize: "11px", lineHeight: "normal" }}
                              className={`block truncate ${active||type.name === selectedName ? "text-selectedText_color" : "text-unselectedText_color"}`}
                            >
                              {type.name}
                            </span>
                          </>
                        }}
                      </Listbox.Option>
                    ))
                  }
                </Listbox.Options>
              </Transition>
            </>
          }
        }
      </Listbox>
    </div >
  );
};

interface ICheckbox {
  id: string;
  value: boolean;
  label: string;
  onChange: (path: string, value: boolean) => void
  disabled?: boolean
  labelStyle?: React.CSSProperties;
  type?: string;
}

export const Checkbox: React.FC<ICheckbox> = ({ disabled, id, value, label, onChange, labelStyle, type }) => {
  const handleLabelClick = () => {
    if(!disabled){
      onChange(id, !value);
    }
  }
  return (
    <div className="panel-div">
      <div className="panel-label"></div>
      <div className="flex items-center" style={{ width: 170, cursor: disabled ? "not-allowed" : "pointer" }} data-test-id={`${type}-${label}`}>
        <div
          id={id}
          style={{
            display: "block", width: "15px", minWidth: 15, height: "15px", border: "1px solid rgba(125, 132, 146, 0.294)",
            boxSizing: "border-box", background: value ? "#0466C8" : "#FFFFFF", borderRadius: "4px", justifyContent: "center", pointerEvents: disabled ? "none" : "initial"
          }}
          className="focus:outline-none"
          onClick={() => { onChange(id, !value) }}
          data-test-id={`${type}-${label}-${value}`}
        >
          {value && (
            <div style={{ marginTop: "-2px", marginLeft: "-1px", display: "flex", alignItems: "center", width: "inherit", height: "inherit" }}>
              <svg viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 7.62163L6.62162 9.24325L9.86487 6.00001" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg></div>
          )}
        </div>
         <label
        onClick={handleLabelClick}
          htmlFor={id}
          className="checkbox-label"
          style={{ fontWeight: value ? 700 : 600, cursor: disabled ? "not-allowed" : "pointer" }}
        >
          <span style={{ ...labelStyle, borderBottom: label === "Fixed" || label === "Widget Visibility" ? "1px dotted rgb(180, 180, 180)" : "unset" }}>{label}</span>
        </label>
      </div>
    </div>
  );
};